
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";

    @Component({})
    export default class NumericId extends Vue {

        numberText: string = "";

        @Prop({ default: true })
        isDevOnly!: boolean;

        @Prop({ default: "" })
        prefix!: string;

        @Prop({ default: "" })
        guid!: string;

        @Watch("guid", { immediate: true })
        async onGuidChanged(val: string, old: string) {
            if (this.isDevOnly && !Utils.isDevelopment()) {
                this.numberText = "";
            }
            else if (Utils.isEmptyOrWhitespace(this.guid)) {
                this.numberText = "0";
            }
            else if (!Utils.isGuid(this.guid)) {
                this.numberText = "err:" + this.guid;
            }
            else {
                this.numberText = (await ApiClient.get(`/api/lookup/numericId?guid=${this.guid}`) as number).toString();
            }
        }
    }
